import { assetUrl } from '#/utils/assetUrl';
import InlineLinks from './InlineLinks';

export interface Tile {
  icon?: string;
  title: string;
  description: string;
}

interface TileGridProps {
  tiles: Tile[];
  contentBase?: string;
}

export default function TileGrid({ tiles, contentBase }: TileGridProps) {
  return (
    <div className="grid w-full grid-cols-2 gap-[10px]">
      {tiles.map((tile, i) => (
        <div
          key={i}
          className="flex flex-col gap-4 rounded-[24px] border border-[#f0f1f2] pl-[18px] pr-4 py-[18px]"
        >
          {tile.icon && (
            <div className="flex items-center">
              <img
                src={assetUrl(tile.icon, contentBase) || tile.icon}
                alt=""
                width={32}
                height={32}
                className="size-8"
              />
            </div>
          )}
          <div className="flex flex-col gap-1">
            <p className="line-clamp-2 text-[18px] font-bold leading-[1.5] text-gray-100">
              <InlineLinks text={tile.title} />
            </p>
            <p className="line-clamp-2 text-[14px] font-medium leading-[1.5] text-gray-60">
              <InlineLinks text={tile.description} />
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
